import { Workspace } from "../workspaces/SDKWorkspace";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Function Definition
export class Membership {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.workspace = new Workspace(model.workspace);
        this.role = model.role;
        this.effectiveRole = model.effectiveRole;
        this.seatType = model.seatType;
    }
}
